
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Bluetooth, Shield, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { useLanguage } from '@/context/LanguageContext';

const LandingPage = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-600 to-blue-500 flex flex-col">
      {/* Header */}
      <header className="py-6 px-6 flex justify-between items-center">
        <div className="flex items-center space-x-2">
          <Bluetooth className="h-6 w-6 text-white" />
          <span className="text-2xl font-bold text-white">bluetooth$</span>
        </div>
      </header>
      
      {/* Main content */}
      <main className="flex-1 flex flex-col items-center justify-center p-6">
        <div className="max-w-md w-full text-center">
          <div className="flex justify-center mb-6">
            <Shield className="h-16 w-16 text-white" />
          </div>
          
          <h1 className="text-4xl font-bold text-white mb-4">
            Bluetooth$
          </h1>
          
          <p className="text-xl text-white/90 mb-8">
            Send Money Anywhere, Anytime with AI Security At Your Fingertips
          </p>
          
          <Card className="mb-6 overflow-hidden">
            <CardContent className="p-0">
              <div className="bg-blue-600 p-4 text-white text-center font-medium">
                Get Started Now
              </div>
              <div className="p-6 space-y-4">
                <Button 
                  className="w-full py-6 text-lg" 
                  onClick={() => navigate('/signup')}
                >
                  Create Account
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Button>
                
                <div className="relative">
                  <div className="absolute inset-0 flex items-center">
                    <div className="w-full border-t border-gray-300"></div>
                  </div>
                  <div className="relative flex justify-center text-sm">
                    <span className="px-2 bg-white text-gray-500">
                      Already have an account?
                    </span>
                  </div>
                </div>
                
                <Button 
                  variant="outline" 
                  className="w-full py-6 text-lg"
                  onClick={() => navigate('/signin')}
                >
                  Sign In
                </Button>
              </div>
            </CardContent>
          </Card>
          
          <div className="grid grid-cols-2 gap-4 mt-8">
            <div className="bg-white/10 backdrop-blur-sm p-4 rounded-xl text-center text-white">
              <h3 className="font-medium mb-2">Secure Payments</h3>
              <p className="text-sm opacity-80">AI-powered security for all your transactions</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm p-4 rounded-xl text-center text-white">
              <h3 className="font-medium mb-2">Bluetooth Tech</h3>
              <p className="text-sm opacity-80">Easy transfers with bluetooth technology</p>
            </div>
          </div>
        </div>
      </main>
      
      {/* Footer */}
      <footer className="py-4 px-6">
        <p className="text-center text-white/60 text-sm">
          © {new Date().getFullYear()} Bluetooth$. {t('rights')}.
        </p>
        <div className="flex justify-center mt-2 space-x-4">
          <button 
            onClick={() => navigate('/privacy')} 
            className="text-white/60 hover:text-white text-sm"
          >
            Privacy Policy
          </button>
          <button 
            onClick={() => navigate('/policy')} 
            className="text-white/60 hover:text-white text-sm"
          >
            Terms of Service
          </button>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
